import axios from "axios";
import { RECEIVED_COLLABORATIONS_URL } from "../../utils";

export const fetchReceivedProfessionalReferrals = () => {
  return axios.get(RECEIVED_COLLABORATIONS_URL);
};
